import { ListItemIcon, ListItemText } from '@mui/material';
import { QuestionTypesEnum } from 'src/@types/Course';
import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Iconify from 'src/components/Iconify';
// ----------------------------------------------------------------------

const OPTIONS = [
  {
    type: QuestionTypesEnum.MCQ,
    label: 'Multiple choice',
    caption: 'One or more correct answers',
    icon: 'eva:checkmark-square-2-outline',
  },
  {
    type: QuestionTypesEnum.trueFalse,
    label: 'True / False',
    caption: 'Two options, one correct',
    icon: 'eva:toggle-right-outline',
  },
  {
    type: QuestionTypesEnum.COMPLETE,
    label: 'Fill in the blank',
    caption: 'Student types the answer',
    icon: 'eva:edit-2-outline',
  },
];

export const AddQuestion = ({ onClick }: { onClick(type: QuestionTypesEnum): void }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="contained"
        aria-controls={open ? 'add-question-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        startIcon={<Iconify icon="eva:plus-fill" />}
      >
        Add question
      </Button>
      <Menu
        id="add-question-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { width: 260 } }}
      >
        {OPTIONS.map((opt) => (
          <MenuItem
            key={opt.label}
            onClick={() => {
              onClick(opt.type);
              handleClose();
            }}
            sx={{ py: 1 }}
          >
            <ListItemIcon>
              <Iconify icon={opt.icon} width={22} height={22} />
            </ListItemIcon>
            <ListItemText primary={opt.label} secondary={opt.caption} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
